import Axios from 'axios';

const optionalParams = {
  query: {},
  headers: {},
  // baseURL: 'http://localhost'
};

export const Get = async (url = '', opts = optionalParams) => {
  const now = new Date();
  const options = {
    ...optionalParams,
    ...opts,
  };

  return Axios({
    url,
    method: 'get',
    baseURL: options.baseURL,
    params: {
      unique: now.getTime(),
      ...options.query,
    },
  });
}

export const Post = async (url = '', data = {}, opts = optionalParams) => {
  const options = {
    ...optionalParams,
    ...opts,
  };

  return Axios({
    url,
    method: 'post',
    baseURL: options.baseURL,
    data,
    ...options,
  });
}

export const Put = async (url = '', data = {}, opts = optionalParams) => {
  const options = {
    ...optionalParams,
    ...opts,
  };

  return Axios({
    url,
    method: 'put',
    baseURL: options.baseURL,
    data,
    ...options,
  });
}
